<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import InputFile from "@/pages/components/form/horizontal/file.vue";

export default {
	components: {Card, InputFile},
	mixins: [FormElements, Changes],
	data() {
		return {
			user: {},
			product: {},

			form: useForm({
				user_id: '',
				comments: '',
				date: '',
				asset: {},
				images: {},
				image_base64: '',
			})
		}
	},
	methods: {
		setMaintenanceHistory(maintenance_history) {
			this.user = maintenance_history.user ?? {};

			this.form.defaults({
				user_id: maintenance_history.user_id,
				comments: maintenance_history.comments,
				date: maintenance_history.date,
				asset: {},
				images: maintenance_history.images,
				image_base64: '',
			});
			this.form.reset();
			this.form.isDirty = false;
		},
	}
}
</script>

<template>
	<div class="row g-4">
		<div class="col-xl-6">
			<Card class="h-100">
				<h2 class="card-title">Onderhoudshistorie Koppeling</h2>

				<Select
					v-model="form.user_id"
					name="user_id"
					label="Werknemer"
					:form="form"
					placeholder="Werknemer"
					:ajaxUrl="route('api.v1.users.list')"
					:currentValueLabel="user.name"
				/>

				<Input
					:form="form"
					v-model="form.date"
					name="date"
					:required="true"
					type="date"
					label="Onderhoudsdatum"
				/>

			</Card>
		</div>

		<div class="col-xl-6">
			<Card class="h-100">
				<h2 class="card-title">Details</h2>

				<Textarea
					v-model="form.comments"
					:form="form"
					type="textarea"
					name="comments"
					label="Omschrijving"
					required
				/>

			</Card>
		</div>
	</div>

	<div class="mt-4">
		<slot name="maintenanceWidget"/>
	</div>
</template>